import request from '@/util/request';
import qs from 'qs';

export const stockWarnPage = (params, options) =>
request.get('/api/v4ward/warehouse/stockWarn/page', Object.assign({}, options, { params }));

export const getWarehouseWarnSetting = (params, options) =>
request.get('/api/v4ward/warehouse/stockWarn/getWarehouseWarnSetting', Object.assign({}, options, { params }));

export const getTotalWarehouseWarnSetting = (params, options) =>
request.get('/api/v4ward/warehouse/stockWarn/getTotalWarehouseWarnSetting', Object.assign({}, options, { params }));

export const stockWarnSave = (params, options) =>
request.post(
'/api/v4ward/warehouse/stockWarn/save',
params,options
);

export const stockWarnUpdate = (params, options) =>
request.post(
'/api/v4ward/warehouse/stockWarn/update',
params,options
);



export const stockWarnDelete = (ids) =>
request.post('/api/v4ward/warehouse/stockWarn/remove?ids='+ids);

export const getMatetial = (params, options) =>
request.get('/api/v4ward/warehouse/stockWarn/getMatetial', Object.assign({}, options, { params }));


export const getWarehouseList = (params, options) =>
request.get('/api/v4ward/warehouse/getWarehouseList', Object.assign({}, options, { params }));